import React, { useCallback, useEffect } from "react";
import { Nullable, TriggeredHook } from "sonobello.utilities.react";

import { useObx } from "../../hooks/useObx";
import ApiRequestPaths from "../../constants/ApiRequestPaths";
import { IDeviceReport } from "../Components/DeviceInfoReporter";

interface IDeviceReportRequest {
  /** The browser which is being used in this local session. */
  browser: string;
  /** The browser version which is being used in this local session. */
  browserVersion: string;
  /** The name of the device operating system associated with this local session. */
  device: Nullable<string>;
  /** The contact id associated with the obx session.
   * @remarks Intentionally using "leadId" as the property name to maintain compatibility with existing data.
   */
  leadId: string;
}

const useReportDeviceInfo: TriggeredHook<boolean, void, boolean, IDeviceReport> = deviceReport => {
  const [executed, setExecuted] = React.useState(false);
  const { res, err, loading, setReq } = useObx<void, IDeviceReportRequest>("reportDeviceInfo", {
    method: "post"
  });

  const execute = useCallback(
    () =>
      setReq(
        p =>
          p && {
            ...p,
            url: ApiRequestPaths.postDeviceInfo(deviceReport.contactId),
            payload: { ...deviceReport, leadId: deviceReport.contactId }
          }
      ),
    []
  );

  useEffect(() => {
    if (res || err) setExecuted(true);
  }, [res, err]);

  return {
    result: executed,
    execute,
    isLoading: loading,
    error: Boolean(err)
  };
};

export default useReportDeviceInfo;
